import * as React from 'react';
import { MachineContext } from '../fsm/useMachine';
import { getCurrentDate } from "../utils/commonFunctions";
import { FlowWindow } from '../../globals';

declare let window: FlowWindow;

/**
 * Extract from {@link FlowWindow} relevant flow metadata
 */
export const getAllFlowInfo = () => {
    const [current,] = React.useContext(MachineContext);
    const { flow } = current.context;
    if (window.flow_json) {
        const json = window.flow_json
        flow.updated = getCurrentDate();
        json.flowboard.flows[0] = flow
        json.flowboard.updated = getCurrentDate();
        return {
            flow: flow,
            metadata: window.flow_metadata,
            json,
            dfi_published:
                window.flow_metadata.flowboard.document_json_published.generic_file_id || 0,
            dfi_draft:
                window.flow_metadata.flowboard.document_json_draft.generic_file_id || 0,
            title: flow.title,
            string_id: window.flow_json.flowboard.string_id
        };
    }
    return {}
}

/**
 * Retrieve unique identifier for Flow from {@link FlowWindow.flow_json}
 */
export const string_id = (typeof window !== "undefined" && window.flow_json) ? window.flow_json.flowboard.string_id : ""

/**
 * Dynamically retrieve string_id at call time (not module load time).
 * Use this instead of the `string_id` constant when the flow may have been
 * created after the editor loaded (e.g. AI-generated flows).
 */
export function getStringId(): string {
    return (typeof window !== "undefined" && window.flow_json?.flowboard?.string_id) || "";
}

/**
 * Slate objects require absolute positioning. This method provides offsets based on static objects outside of the Konva Canvas
 * @param stage_w {@link Flow.view_size} width
 * @param stage_h {@link Flow.view_size} height
 */
export const determineOffsetAndRatios = (stage_w: number, stage_h: number) => {
    let heightOffset =
        parseFloat(
            window
                .getComputedStyle(document.getElementById("control_panel")!)
                .height!.replace("px", ""),
        ) +
        parseFloat(
            window
                .getComputedStyle(document.getElementById("screen_select")!)
                .height!.replace("px", ""),
        ) +
        40 // Buffer for artboard padding and margins

    let widthOffset = 80
    if (document.getElementById("left-flyout")) {
        widthOffset = parseFloat(
            window
                .getComputedStyle(document.getElementById("left-flyout")!)
                .width!.replace("px", ""),
        )
    }

    return calculateAspectRatioFit(
        stage_w,
        stage_h,
        window.innerWidth - widthOffset,
        window.innerHeight - heightOffset,
    )
}

/**
 * Determines a multiplier to scale source to be as large as possible but keeping aspect ratio
 * @param srcWidth given width
 * @param srcHeight given height
 * @param maxWidth maximum width possible
 * @param maxHeight maximum height possible
 */
export function calculateAspectRatioFit(
    srcWidth: number,
    srcHeight: number,
    maxWidth: number,
    maxHeight: number,
) {
    // Limit ratio to 1.0 max - don't scale up beyond original size
    // The working coordinate space is defined by srcWidth/srcHeight (flow.viewSize)
    // Scaling beyond 1.0 makes canvas bigger but doesn't expand the working area
    var ratio = Math.min(maxWidth/srcWidth, maxHeight/srcHeight, 1)
    return {
        stage_width: srcWidth * ratio,
        stage_height: srcHeight * ratio,
        ratio,
    }
}

function divideLargestOnBottom(num1: number, num2: number): number {
    return Math.min(num1/num2, num2/num1)
}

/**
 * `flowvella.local` is the only non-production environment
 */
export function isProd(): boolean {
    return !window.location.href.includes("flowvella.local")
}